// ModelDisplayDialog.js
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {string} model a text interpretation of the .inp file
 * @returns UI component to display .inp file text contents.
 */

const displayStyle = {
  position: 'absolute', 
  height: 'calc(100% - 100px)',
  width: 'calc(100% - 30px)', 
  display: 'inline', 
  overflow: 'scroll', 
  background: 'radial-gradient(circle at 3% 25%,#002853 0,#040c18 100%,violet 0)', 
  color: 'white'
}

export default function ModelDisplayDialog({model}) {
  return(
    <>
    <div>
      <div style={{ backgroundColor:'black'}} >
        .inp File
      </div>
      <div style={displayStyle}>
        <pre className="rpt-contents">{model}</pre>
      </div>
    </div>
    </>
  )
}
